<template>
  <div style="display: flex; align-items: center; justify-content: space-between;">
    <v-breadcrumbs
      style="
        color: var(--Black, #212121);
        text-align: right;
        font-family: Cairo;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 135.5%;
      "
      :items="bcItems"
    >
      <template v-slot:divider>
        <span>/</span>
      </template>
    </v-breadcrumbs>

  </div>
</template>

<script>

export default {
  name: "BreadcrumbsComponent",
  components: {
  },
  computed: {
    bcItems() {
      if (this.$store.state.bcItems.length) {
        return this.$store.state.bcItems.map((el) => ({
          text: el,
        }));
      }
      return [
        { text: this.$route.meta.group || "الرئيسية" },
        { text: this.$route.meta.page_name },
      ];
    },
  },
  methods: {
    onThemeChanged(newTheme) {
      // Emit the theme change event to parent components
      this.$emit('theme-changed', newTheme);
    },
  },
};
</script>

<style>
.v-breadcrumbs li:nth-child(even) {
  padding: 0 5px;
}
.v-breadcrumbs li {
  letter-spacing: 1px;
}
@media (max-width: 600px) {
  .v-breadcrumbs {
    padding: 30px 0 20px 0 !important;
  }
}
</style>
